<template>
  <main class="page-school-territory">
    <div>
      <div v-if="loading" class="loading"></div>
      <template v-else>
        <div class="submenu">
          <ul class="clean flex flex-justify-center">
            <li v-for="(item, index) in category_1" :key="'c1_' + index" class="text-center">
              <a role="button" :class="{active: item.active}" @click="filterArticles(item, {categoria_1: item.id}, $event)">{{item.label}}</a>
            </li>
          </ul>
        </div>
        <div class="container">
          <div class="row row-middle row-filter">
            <div class="col md-6" v-html="phrase"></div>
            <div class="col col-filter md-6">
              <div class="row row-middle">
                <div class="col xs-6 text-right">Actores de la Escuela</div>
                <div class="col xs-6">
                  <div class="custom-select">
                    <select ref="filter_category_2" v-model="input.filter_2" @change="onFilterChange($event)">
                      <option
                        v-for="(item, index) in category_2" :key="'c2_' + index"
                        :value="item.id"
                       >{{item.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div v-if="loadingArticles" class="loading"></div>
          <template v-else>
            <div class="row row-articles">
              <div
                v-for="(item, index) in articles" :key="'a_' + index"
                class="col col-article xs-6 md-4">
                <article class="preview color-blue-1" @click="gotoItem(item)">
                  <div class="image">
                    <img :src="item.image">
                    <div class="overlay">
                      <span class="btn btn-purple-1">Seguir leyendo</span>
                    </div>
                  </div>
                  <div class="text">
                    <div class="type font-size-s"><span>{{item.type}}</span></div>
                    <h2 class="title font-size-m font-bold">
                      <router-link :to="articlePath(item)">{{item.label}}</router-link>
                    </h2>
                  </div>
                </article>
              </div>
            </div>
            <Pager :options="pager" @changePage="onChangePage" />
          </template>
        </div>
      </template>
      <Banner1 />
    </div>
  </main>
</template>

<script>
import PageBaseMixin from '@/mixins/PageBase';

import Pager from '@/components/Pager';
import Banner1 from '@/components/Banner1';

export default {
  components: {Pager,Banner1},
  mixins: [PageBaseMixin],
  title: 'Escuela en territorio | Escuela de liderazgo',

  data() {
    return {
      loading: false,
      loadingArticles: false,
      input: {
        filter_2: 0,
      },
      filter: {},
      phrase: '',
      category_1: [{
        label: 'Todos',
        id: 0,
        active: true,
      }],
      category_2: [{
        label: 'Todos',
        id: 0,
        active: true,
      }],
      articles: [],
      pager: {
        current_page: 0,
        total_items: 0,
        total_pages: 0,
        items_per_page: 0
      }
    }
  },

  methods: {
    articlePath(item){
      return {name: 'school-territory-detail', params: {article: `articulo-${item.id}`}};
    },

    gotoItem(item){
      // :to="{name: `schoolTerritory/${item.self}_${item.id}`}" 
      this.$router.push(this.articlePath(item));
    },

    resetFiltersComponents(){
      this.input.filter_2 = 0;
      this.category_1 = this.category_1.map(v => {
        v.active = false;
        return v;
      });

      this.category_1[0].active = true;
    },

    onChangePage(l){
      if(l > -1){
        this.filter.page = l;
        this.loadArticles();
      }
    },

    onFilterChange(e){
      this.resetFiltersComponents();
      const id = e.target.value;
      this.input.filter_2 = id;

      if(id == 0){
        this.filter = {};
      } else {
        this.filter = {categoria_2: id};
      }
      this.loadArticles();
    },

    filterArticles(item, opts){
      this.resetFiltersComponents();
      this.category_1 = this.category_1.map(v => {
        if(v.id == item.id){
          v.active = true;
        } else {
          v.active = false;
        }
        
        return v;
      });
      if(item.id == 0){
        this.filter = {};
      } else {
        this.filter = opts;
      }
      this.loadArticles();
    },

    loadArticles(){
      this.loadingArticles = true;
      return this.$api.get('/v1/articles', this.filter).
        then(({body}) => {
          this.articles = body.rows;
          this.pager = body.pager;
        })
        .finally(() => {
          this.loadingArticles = false;
        });
    }
  },

  created(){
    const p1 = this.$api.get('/v1/terms/categoria_1')
      .then(({body}) => {
        body.rows.forEach(v => {
          v.active = false;
          this.category_1.push(v);
        });
      });

    const p2 = this.$api.get('/v1/terms/categoria_2')
      .then(({body}) => {
        body.rows.forEach(v => {
          v.active = false;
          this.category_2.push(v);
        });
        // this.category_2 = body.rows;
      });

    const p3 = this.loadArticles();

    this.$api.get('/v1/phrase_school_territory')
      .then(({body}) => {
        this.phrase = (body.rows[0] && body.rows[0].content) || '';
      });

    this.loading = true;
    Promise.all([p1, p2, p3])
      .finally(() => {
        this.loading = false;
      });
  }
}
</script>